import React from 'react';
import { useAPIContext } from '../../context/api';
import { AudioAPI } from '../../../../constructs/audio/interface';

/**
 * Llama al endpoint sincrónico `POST /audio/tts`. Devuelve el audioUrl + audioId
 * o null si falla. La latencia es ~1-2s (tiempo de Cartesia).
 */
export const useGenerateAudioTts = () => {
  const { callEndpoint } = useAPIContext();

  const generateAudioTts = React.useCallback(
    async (script: string) => {
      try {
        const res = await callEndpoint<AudioAPI, 'audio-tts'>('audio', '/tts', 'POST', { script });
        if (!res) throw new Error('Respuesta del servidor inesperada');
        return res;
      } catch (error: any) {
        console.error('Error al generar TTS:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { generateAudioTts };
};
